module.exports = "https://cdn.realtymogul.com/static/media/HIW_steps_2.dc1b91b6.jpg";